import HomePage from "../views/HomePage.vue";
import ResidentsList from "../views/ResidentsList.vue";
import ResidentDocument from "../views/ResidentDocument.vue";
import ResidentContact from "../views/ResidentContact.vue";
import ResidentInsurance from "../views/ResidentInsurance.vue";
import ResidentProvider from "../views/ResidentProvider.vue";
import ResidentVital from "../views/ResidentVital.vue";
import ResidentCharting from "../views/ResidentCharting.vue";
import ResidentAdl from "../views/ResidentAdl.vue";
import ResidentSchedule from "../views/ResidentSchedule.vue";
import DashBoard from "../views/DashBoard.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";
import CareAssistants from "@/views/CareAssistants.vue";
import LogIn from "../views/LogIn.vue";
import ContactForm from "../views/ContactForm.vue";
import { checkTokenExpiration } from '../utils/auth';
import store from '../store/store.js';

import { createRouter, createWebHistory } from "vue-router";

const routes = [
 {
   path: "/home",
   name: "home",
   component: HomePage,
 },
 {
  path: "/contactform",
  name: "contactform",
  component: ContactForm,
},
 {
  path: "/",
  name: "login",
  component: LogIn,
},
 {
    path: "/residentslist:id",
    name: "residentslist",
    component: ResidentsList,
    meta: { requiresAuth: true }
  },
  {
    path: "/residentdocument:id",
    name: "residentdocuments",
    component: ResidentDocument,
    meta: { requiresAuth: true }
  },
  {
    path: "/residentcontact:id",
    name: "residentcontacts",
    component: ResidentContact,
    meta: { requiresAuth: true }
  },
  {
    path: "/residentinsurance:id",
    name: "residentinsurances",
    component: ResidentInsurance,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentprovider:id",
    name: "residentproviders",
    component: ResidentProvider,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentvital:id",
    name: "residentvitals",
    component: ResidentVital,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentcharting:id",
    name: "residentcharting",
    component: ResidentCharting,
  }, 
  {
    path: "/residentadl:id",
    name: "residentadl",
    component: ResidentAdl,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/residentschedule",
    name: "residentschedule",
    component: ResidentSchedule,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashBoard,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/careassistants",
    name: "careassistants",
    component: CareAssistants,
    meta: { requiresAuth: true }
  }, 
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: PrivacyPolicy,
  }, 
  {
    path: "/termsofuse",
    name: "termsofuse",
    component: TermsOfUse,
  }, 
];

const router = createRouter({
 history: createWebHistory(),
 routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = checkTokenExpiration();
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    store.dispatch('logout');
    next({ name: 'login' });
  } else {
    next();
  }
});


export default router;
